import { useEffect, useState } from 'react';
import cn from 'classnames';
import PerekrestokLogoIcon from 'shared/icons/perekrestok-logo.svg';
import PyaterochkaLogoIcon from 'shared/icons/pyaterochka-logo.svg';
import ChizhikLogoIcon from 'shared/icons/chizhik-logo.svg';
import { LogoutButton } from 'shared/ui/logout-button';
import { Retailer } from '../types';
import styles from './header.module.scss';

const MIN_SCROLL_SHOW_HEADER = 200;

type HeaderProps = { retailer: Retailer };

const RetailerLogo = ({ retailer }: { retailer: Retailer }) => {
  if (retailer === 'chizhik') {
    return <img src={ChizhikLogoIcon} alt={retailer} width={122} height={60} />;
  }
  if (retailer === 'pyaterochka') {
    return <img src={PyaterochkaLogoIcon} alt={retailer} width={143} height={34} />;
  }

  if (retailer === 'perekrestok') {
    return <img src={PerekrestokLogoIcon} alt={retailer} width={191} height={25} />;
  }

  return null;
};
export const Header = ({ retailer }: HeaderProps) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const position = window.pageYOffset;
      setIsVisible(position > MIN_SCROLL_SHOW_HEADER);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <div className={cn(styles.header, isVisible ? styles.visible : styles.hidden)}>
      <RetailerLogo retailer={retailer} />
      <LogoutButton />
    </div>
  );
};
